<template>
  <div>
    <!-- Edit -->
    <a-modal
      v-model="visible"
      title="Edit exam setting details"
      onOk="handleOk"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleEdit"
          >Edit Exam Setting</a-button
        >
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form">
          <!-- Name -->
          <a-form-item label="Name">
            <a-input
              placeholder="Name"
              v-decorator="[
                'name',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input exam setting name!'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>

          <!-- Score -->
          <a-form-item label="% score to give rankings upto">
            <a-input-number
              placeholder="% score to give rankings upto"
              v-decorator="[
                'score_to_give_rankings',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input % score to give rankings upto!'
                    }
                  ]
                }
              ]"
              style="width:470px"
            />
          </a-form-item>

          <!-- Max Rank -->
          <a-form-item label="Maximum ranks allowed">
            <a-input-number
              placeholder="Maximum ranks allowed"
              v-decorator="[
                'max_ranks_allowed',
                {
                  rules: [
                    { required: true, message: 'Please input maximum ranks allowed!' }
                  ]
                }
              ]"
              style="width:470px"
            />
          </a-form-item>

          <!-- Include Attendance -->
          <a-form-item label="Include Attendance">
            <a-radio-group
              v-decorator="[
                'include_attendance',
                {
                  rules: [
                    { required: true, message: 'This value is required' }
                  ],
                  initialValue: 0
                }
              ]"
            >
              <a-radio :value="1">Yes</a-radio>
              <a-radio :value="0">No</a-radio>
            </a-radio-group>
          </a-form-item>

          <!-- Description -->
          <a-form-item label="Description">
            <a-textarea
              placeholder="Description"
              :autosize="{ minRows: 2 }"
              v-decorator="['description']"
            />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { pick, mapValues } from 'lodash'

export default {
  name: 'EditExamType',
  mounted: function() {
    this.$eventBus.$on('openExamTypeEditModal', this.showModal)
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      examsettingid: null,
    }
  },
  methods: {
    showModal: function(examsettingid) {
      this.examsettingid = examsettingid
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http.get('/api/exam/settings/' + examsettingid).then(({ data }) => {
        const editData = pick({ ...data.data }, [
          'name',
          'score_to_give_rankings',
          'max_ranks_allowed',
          'include_attendance',
          'description',
        ])
        const fieldsData = mapValues({ ...editData }, function(value) {
          return value !== null ? value : undefined
        })
        this.form.setFieldsValue(fieldsData)
        this.spinning = false
        this.loading = false
      })
    },
    handleEdit: function(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              this.$http
                .patch('/api/exam/settings/' + this.examsettingid, {
                  name: values.name,
                  description: values.description,
                  score_to_give_rankings: values.score_to_give_rankings,
                  max_ranks_allowed: values.max_ranks_allowed,
                  include_attendance: values.include_attendance,
                })
                .then(() => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully edited',
                    description: 'Exam type details edited successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
